import { PageType } from '@app-types/PageType'
import Tooltip from '@components/shared/Tooltip/Tooltip'
import { useUserData } from '@contexts/UserDataContext'
import toast from 'react-hot-toast'
import { FaBookmark, FaRegBookmark } from 'react-icons/fa'
import { DUA_PART_SEPERATOR, getDuaPageAndPartKey } from './duaPartHelper'

type DuaPartBookmarkProps = {
  type: PageType
  page: number
  partKey: number
}

const DuaPartBookmark = ({ type, page, partKey }: DuaPartBookmarkProps) => {
  const { userData, updateUserData } = useUserData()

  const handleBookmark = () => {
    updateUserData(type, `${page}${DUA_PART_SEPERATOR}${partKey}`)
    toast.success('Sayfa ve Bölüm işaretlendi')
  }

  const handleAlreadyBookmarked = () => {
    toast.success('Zaten burayı işaretlediniz')
  }

  const [bookmarkedPage, bookmarkedPart] = getDuaPageAndPartKey(userData[type])
  const isPartBookmarked =
    Number(page) === Number(bookmarkedPage) && Number(partKey) === Number(bookmarkedPart)

  return (
    <>
      {isPartBookmarked ? (
        <Tooltip content="Kaldığınız yer">
          <button
            type="button"
            onClick={handleAlreadyBookmarked}
            aria-label="Kaldığınız yer"
            className="p-1.5 transition-transform hover:scale-110 active:scale-95 text-teal-500 dark:text-teal-400"
          >
            <FaBookmark className="text-base sm:text-lg" />
          </button>
        </Tooltip>
      ) : (
        <Tooltip content="Kaldığım yer olarak işaretle">
          <button
            type="button"
            onClick={handleBookmark}
            aria-label="Sayfayı işaretle"
            className="p-1.5 transition-transform hover:scale-110 active:scale-95 text-slate-400 hover:text-slate-700 dark:hover:text-white"
          >
            <FaRegBookmark className="text-base sm:text-lg" />
          </button>
        </Tooltip>
      )}
    </>
  )
}

export default DuaPartBookmark
